// extracted by mini-css-extract-plugin
export default {"warn":"WarnTemplate_warn__1joT7"};